export const notification_actions = {
  BLOOD_SUGAR_LOGGING_SCREEN: { id: 101, label: 'Blood Sugar Logging Screen' },
  BLOOD_PRESSURE_LOGGING_SCREEN: { id: 102, label: 'Blood Pressure Logging Screen' },
  HBA1C_LOGGING_SCREEN: { id: 103, label: 'HbA1c Logging Screen' },
  EXERCISE_LOGGING_SCREEN: { id: 104, label: 'Exercise Logging Screen' },
  MEDICATION_LIST_SCREEN: { id: 105, label: 'Medication List Screen' },
  LOG_BOOK_ALL: { id: 106, label: 'Log Book All' },
  LOGBOOK_FILTERED_BY_BLOOD_SUGAR: { id: 107, label: 'Logbook Filtered by Blood Sugar' },
  LOGBOOK_FILTERED_BY_BLOOD_PRESSURE: { id: 108, label: 'Logbook Filtered by Blood Pressure' },
  LOGBOOK_FILTERED_BY_HBA1C: { id: 109, label: 'Logbook Filtered by HbA1c' },
  LOGBOOK_FILTERED_BY_EXERCISE: { id: 110, label: 'Logbook Filtered by Exercise' },
  LOGBOOK_FILTERED_BY_MEDICATION: { id: 111, label: 'Logbook Filtered by Medication' },
  INSIGHTS_SCREEN: { id: 112, label: 'Insights Screen' },
  INSIGHTS_SCREEN_AT_A_SPECIFIC_DATE: { id: 113, label: 'Insights Screen at a Specific Date' },
  HOME_SCREEN: { id: 114, label: 'Home' },
  ASK_DRU_SCREEN: { id: 115, label: 'Dru support' },
  DEVICES_SCREEN: { id: 116, label: 'Devices Screen' },
  MY_HEALTH_SCREEN: { id: 117, label: 'My Health Screen' },
  PROFILE_SCREEN: { id: 118, label: 'Profile Screen' },
  ACCOUNT_SCREEN: { id: 119, label: 'Account Screen' },
  MEDICAL_RECORDS_TIMELINE: { id: 120, label: 'Medical Records Timeline' },
  MEDICAL_RECORDS_TIMELINE_FILTERED_BY_A_SPECIFIC_RECORD_TYPE: {
    id: 121,
    label: 'Medical Records Timeline Filtered by a Specific Record Type',
  },
  MEDICAL_RECORDS_TIMELINE_FILTERED_BY_A_SPECIALITY: {
    id: 122,
    label: 'Medical Records Timeline Filtered by a Speciality',
  },
  MEDICAL_RECORD_IN_VIEW_MODE: { id: 123, label: 'Medical Record in View Mode' },
  ADDING_MEDICAL_RECORDS_STEP_1_SCREEN: { id: 124, label: 'Adding Medical Records Step 1 Screen' },
  SETTINGS_SCREEN: { id: 125, label: 'Settings Screen' },
  SET_NOTIFICATION: { id: 126, label: 'Notifications' },
  PDF_PREVIEW: { id: 127, label: 'PDF Preview' },

  DISCOVER_SCREEN: { id: 128, label: 'Discover Screen' },
  MY_PLAN_SCREEN: { id: 129, label: 'Subscription page' },
  CART_SCREEN: { id: 130, label: 'Cart Screen' },
  COPMANION_MESSAGE_SCREEN: { id: 131, label: 'Companion Message Screen' },
  WEIGHT_LOGGING_SCREEN: { id: 132, label: 'Weight Logging Screen' },
  WATER_LOGGING_SCREEN: { id: 133, label: 'Water Logging Screen' },
  LOG_NEW: { id: 134, label: 'Log New' },
  ARRANGE_TABS: { id: 135, label: 'Arrange Tabs' },
  CARBOHYDRATES: { id: 136, label: 'Carbohydrates' },
  INVOICE: { id: 137, label: 'Invoice' },
  NOUR_CHATBOT: { id: 143, label: 'Nour Chatbot' },
  SUBSCRIPTION_SCREEN: { id: 145, label: 'Subscription Screen' },
  EXTERNAL_URL: { id: 146, label: 'External URL' },
  OFFER_DETAILS_SCREEN: { id: 147, label: 'Specific Offer and ads' },
  OFFER_CATEGORY_SCREEN: { id: 148, label: 'Specific offer category' },
  FRESHCHAT_BOT: { id: 139, label: 'Freshchat Bot' },
  NOTIFICATION_SCREEN: { id: 300, label: 'Notification Screen' },
  OFFERS_AND_ADS_PAGE: { id: 128, label: 'Offers and ads page' },

  SUBSCRIPTION_FILTERED_BY_ONE_MONTH: { id: 201, label: 'Subscription Filtered by One Month' },
  SUBSCRIPTION_FILTERED_BY_THREE_MONTHS: {
    id: 202,
    label: 'Subscription Filtered by Three Months',
  },
  SUBSCRIPTION_FILTERED_BY_SIX_MONTHS: { id: 203, label: 'Subscription Filtered by Six Months' },
  SUBSCRIPTION_FILTERED_BY_twelve_MONTHS: {
    id: 204,
    label: 'Subscription Filtered by Twelve Months',
  },

  PLANS_FILTERED_BY_FIRST_PLAN: { id: 301, label: 'Plans Filtered by First Plan' },
  PLANS_FILTERED_BY_SECOND_PLAN: { id: 302, label: 'Plans Filtered by Second Plan' },
  PLANS_FILTERED_BY_THIRD_PLAN: { id: 303, label: 'Plans Filtered by Third Plan' },
  PLANS_FILTERED_BY_FOURTH_PLAN: { id: 304, label: 'Plans Filtered by Fourth Plan' },
  PLANS_FILTERED_BY_FIFTH_PLAN: { id: 305, label: 'Plans Filtered by Fifth Plan' },
  PLANS_FILTERED_BY_SIXTH_PLAN: { id: 306, label: 'Plans Filtered by Sixth Plan' },
  PLANS_FILTERED_BY_SEVENTH_PLAN: { id: 307, label: 'Plans Filtered by Seventh Plan' },
  PLANS_FILTERED_BY_EIGHTH_PLAN: { id: 308, label: 'Plans Filtered by Eighth Plan' },

  MEDICATIOM_REMINDER: { id: 401, label: 'Medication Reminder' },
  BLOOD_SUGAR_REMINDER: { id: 402, label: 'Blood Sugar Reminder' },
  HAB1C_REMINDER: { id: 403, label: 'HbA1c Reminder' },
  BLOOD_PREASURE_REMINDER: { id: 404, label: 'Blood Pressure Reminder' },
  WORKOUT_REMINDER: { id: 406, label: 'Workout Reminder' },
  WATER_REMINDER: { id: 407, label: 'Water Reminder' },
};

export const getActionLabel = (action) => {
  if (!action) return 'N/A';

  // If it's a key in the object
  if (notification_actions[action]) {
    return notification_actions[action].label;
  }

  // If it's an ID, find the corresponding entry
  const entry = Object.values(notification_actions).find((item) => item.id === Number(action));
  return entry ? entry.label : 'N/A';
};
